import React, { useMemo } from "react";
import { useEventContext } from '../../context/EventContext';
import PageBlockComponent from "../../components/PageBlockComponent";
import { useUserContext } from "../../context/UserContext";
import pages from "../../pages";

export default ({ page }) => {
    const { event } = useEventContext();
    const { participationType } = useUserContext();

    const moduleBlocks = {
        moduleEpisode: ['hall-description', 'hall-episodes'],
        moduleShop: ['shop']
    }

    const checkModule = (template) => {
        const module = Object.keys(moduleBlocks).find(module => moduleBlocks[module].includes(template));
        return !module || event[module]?.enabled;
    }

    const checkPType = (blockPType) =>
        Boolean(!participationType || !blockPType || blockPType === 'hybrid' || blockPType === participationType);

    const PageComponent = pages[page.template] || pages['default'];
    const blocks = page.blocks.filter(({template, participationType}) => checkModule(template) && checkPType(participationType));

    return (
        <PageComponent page={page} event={event}>
            {blocks
                .map((block, index) => (
                    <PageBlockComponent key={index} block={block} page={page} settings={page?.settings} />
                ))
            }
        </PageComponent>
    );
}

